module.exports = __webpack_public_path__ + "img/p_sz_9.3ebf4ea3.svg";